export type NotificationKind =
  | 'inviteAccepted'
  | 'inviteReceived'
  | 'newListing'
  | 'commentOnMyListing'
  | 'replyAfterMyComment'
  | 'newMessage';

export type NotificationSetting = {
  kind: NotificationKind;
  channel: 'push';
  collectionId: string | null;
  enabled: boolean;
};

/** The six kinds, in the order every client shows them (020 research G17). */
export const NOTIFICATION_KINDS: readonly NotificationKind[] = [
  'inviteAccepted',
  'inviteReceived',
  'newListing',
  'commentOnMyListing',
  'replyAfterMyComment',
  'newMessage',
];

const LABELS: Record<NotificationKind, string> = {
  inviteAccepted: 'Someone accepts my invite',
  inviteReceived: 'I receive an invite',
  newListing: 'New listings',
  commentOnMyListing: 'Comments on my listings',
  replyAfterMyComment: 'Replies after my comments',
  newMessage: 'Messages',
};

export function notificationKindLabel(kind: NotificationKind): string {
  return LABELS[kind];
}

/** The settings with one kind's push turned on or off, the others as they were. */
export function withSetting(
  settings: NotificationSetting[],
  kind: NotificationKind,
  enabled: boolean,
): NotificationSetting[] {
  return settings.map((s) =>
    s.kind === kind && s.channel === 'push' && s.collectionId === null ? { ...s, enabled } : s,
  );
}
